// @ts-nocheck

import React from 'react';

import { ModalContentSpacing, ModalFormat } from '../../constants/ui/modal';
import theme from '../../styled-components/dark';
import Modal from '../Modal';
import UserAccountGraphicsPreferencesContainer from '../UserAccountGraphicsPreferences/UserAccountGraphicsPreferencesContainer';

type UserAccountGraphicsPreferencesModalViewProps = {
  className?: string;
};

const UserAccountGraphicsPreferencesModalView = ({ className }: UserAccountGraphicsPreferencesModalViewProps) => {
  return (
    <Modal
      contentSpacing={ModalContentSpacing.NONE}
      format={ModalFormat.FULLSCREEN}
      hasNavBarSpacing
      zIndex={theme.ZIndices.GraphicsPreferencesModal}
    >
      <UserAccountGraphicsPreferencesContainer className={className} />
    </Modal>
  );
};

export default UserAccountGraphicsPreferencesModalView;
